import { GeofenceType } from '@cobliteam/common-types/src/geofenceV3';
import Icon from '@cobliteam/ui/icons';
import { colors } from '@cobliteam/ui/theme';

export type GeofenceTypeItemType = {
  label: string;
  icon: React.ReactElement;
  colorClass: string;
  textColor: string;
  activeColor: string;
  backgroundColor: string;
};

const GeofenceTypeItems: Record<GeofenceType, GeofenceTypeItemType> = {
  [GeofenceType.BASE]: {
    label: 'Base',
    icon: <Icon name='cb-geofences-home' />,
    colorClass: 'text-primary-11',
    textColor: colors.primary[11],
    activeColor: colors.primary[11],
    backgroundColor: colors.primary[4],
  },
  [GeofenceType.HEADQUARTER]: {
    label: 'Sede',
    icon: <Icon name='house' />,
    colorClass: 'text-accessory-sky-11',
    textColor: colors.accessory.sky[11],
    activeColor: colors.accessory.sky[11],
    backgroundColor: colors.accessory.sky[4],
  },
  [GeofenceType.SUPPLY]: {
    label: 'Abastecimento',
    icon: <Icon name='fuel' />,
    colorClass: 'text-accessory-purple-11',
    textColor: colors.accessory.purple[11],
    activeColor: colors.accessory.purple[11],
    backgroundColor: colors.accessory.purple[4],
  },
  [GeofenceType.MAINTENANCE]: {
    label: 'Manutenção',
    icon: <Icon name='cb-maintenance' />,
    colorClass: 'text-accessory-tomato-11',
    textColor: colors.accessory.tomato[11],
    activeColor: colors.accessory.tomato[11],
    backgroundColor: colors.accessory.tomato[4],
  },
  [GeofenceType.CLIENT]: {
    label: 'Cliente',
    icon: <Icon name='user-round' />,
    colorClass: 'text-success-11',
    textColor: colors.success[11],
    activeColor: colors.success[11],
    backgroundColor: colors.success[4],
  },
  [GeofenceType.STATE]: {
    label: 'Estado',
    icon: <Icon name='map-pinned' />,
    colorClass: 'text-gray-11',
    textColor: colors.gray[11],
    activeColor: colors.gray[11],
    backgroundColor: colors.gray[3],
  },
  [GeofenceType.CITY]: {
    label: 'Cidade',
    icon: <Icon name='map-pinned' />,
    colorClass: 'text-gray-11',
    textColor: colors.gray[11],
    activeColor: colors.gray[11],
    backgroundColor: colors.gray[3],
  },
  [GeofenceType.PATH]: {
    label: 'Rota',
    icon: <Icon name='route' />,
    colorClass: 'text-accessory-brown-11',
    textColor: colors.accessory.brown[11],
    activeColor: colors.accessory.brown[11],
    backgroundColor: colors.accessory.brown[4],
  },
  [GeofenceType.OTHER]: {
    label: 'Outro',
    icon: <Icon name='map-pin' />,
    colorClass: 'text-warning-11',
    textColor: colors.warning[11],
    activeColor: colors.warning[11],
    backgroundColor: colors.warning[4],
  },
  [GeofenceType.DEFAULT]: {
    label: 'Local',
    icon: <Icon name='map-pin' />,
    colorClass: 'text-gray-11',
    textColor: colors.gray[11],
    activeColor: colors.gray[11],
    backgroundColor: colors.gray[4],
  },
};

export default GeofenceTypeItems;
